export enum EntityTypeEnum {
    Shareholder = 'shareholder',
    User = 'user',
    Report = 'report',
    Trader = 'trader',
    Transaction = 'transaction'
}
